(function () {
  'use strict';

  // --- Keyboard vs Mouse Detection ---
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      document.documentElement.classList.add('keyboard-nav');
      document.documentElement.classList.remove('mouse-nav');
    }
  });

  document.addEventListener('mousedown', function () {
    document.documentElement.classList.add('mouse-nav');
    document.documentElement.classList.remove('keyboard-nav');
  });

  // --- Reduced Motion Detection ---
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function handleMotionPreference(mq) {
    document.documentElement.classList.toggle('reduce-motion', mq.matches);
    window.__reducedMotion = mq.matches;
  }

  handleMotionPreference(prefersReducedMotion);
  if (prefersReducedMotion.addEventListener) {
    prefersReducedMotion.addEventListener('change', handleMotionPreference);
  }

  // --- High Contrast Mode ---
  const prefersHighContrast = window.matchMedia('(prefers-contrast: more)');

  function handleContrastPreference(mq) {
    document.documentElement.classList.toggle('high-contrast', mq.matches);
  }

  handleContrastPreference(prefersHighContrast);
  if (prefersHighContrast.addEventListener) {
    prefersHighContrast.addEventListener('change', handleContrastPreference);
  }

  // --- Screen Reader Announcement Utility ---
  /**
   * One region per politeness, both shipped by layout/theme.liquid. aria-live was
   * previously set only on the branch that creates the region, and theme.liquid
   * already ships a polite one, so that branch never ran on a real page and the
   * priority argument did nothing at all: every assertive message was delivered
   * politely. Switching aria-live on a live region is not a fix either, since
   * assistive tech registers a region's politeness when it enters the
   * accessibility tree and does not reliably re-read it.
   *
   * Keeping them separate also stops one from clobbering the other: both paths
   * clear the node before writing, so a polite message queued in the same frame as
   * an urgent one used to lose its text.
   */
  const LIVE_REGION_IDS = { polite: 'sr-live-region', assertive: 'sr-live-region-assertive' };

  window.__announce = function (message, priority) {
    const politeness = priority === 'assertive' ? 'assertive' : 'polite';
    const id = LIVE_REGION_IDS[politeness];
    let region = document.getElementById(id);
    if (!region) {
      // Fallback only. A page reaching this has lost the region the layout ships,
      // and an element that enters the tree in the same frame as its message is
      // announced less reliably than one that was already there.
      region = document.createElement('div');
      region.id = id;
      region.setAttribute('aria-live', politeness);
      region.setAttribute('aria-atomic', 'true');
      region.className = 'visually-hidden';
      document.body.appendChild(region);
    }

    // Clear then set to trigger announcement
    region.textContent = '';
    requestAnimationFrame(function () {
      region.textContent = message;
    });
  };

  // --- Focus Trap Utility ---
  window.__createFocusTrap = function (container) {
    const FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const previousFocus = document.activeElement;

    function getFocusable() {
      return Array.prototype.slice
        .call(container.querySelectorAll(FOCUSABLE))
        .filter(function (el) {
          return el.offsetParent !== null;
        });
    }

    function handleKeydown(e) {
      if (e.key !== 'Tab') return;
      const focusable = getFocusable();
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    container.addEventListener('keydown', handleKeydown);

    // Focus the first focusable element
    const focusable = getFocusable();
    if (focusable.length > 0) focusable[0].focus();

    return {
      release: function () {
        container.removeEventListener('keydown', handleKeydown);
        if (previousFocus && previousFocus.focus) {
          previousFocus.focus();
        }
      },
    };
  };

  // --- Escape Key Handler for Modals/Drawers ---
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      // Close any open modals/drawers
      const openModals = document.querySelectorAll(
        '[data-modal-open="true"], [aria-expanded="true"].modal, .drawer.is-open'
      );
      for (let i = 0; i < openModals.length; i++) {
        const closeBtn = openModals[i].querySelector('[data-close], .modal__close, .drawer__close');
        if (closeBtn) closeBtn.click();
      }
    }
  });
})();
